import { FC } from 'react'
import { CircularProgress } from '@mui/material'

/* Utils */
import { MAX_PINNED_LABELS_COUNT } from '../../../chart-utils'
import { CustomLabelCountI } from 'models'

/* Components */
import PinSvg from 'ui/components/svg/labels/PinSvg'
import { LibraryDetailsHoverTooltip } from 'ui/components/tooltip/LibraryDetailsTooltip'
import { LoadingWrapper, IconButton } from './labelCardPinButton.styles'

interface Props {
  isPinned: boolean
  togglePin: () => void
  customLabelsCount: CustomLabelCountI
  pinningLabel: boolean
}

const LabelCardPinButton: FC<Props> = ({ isPinned, togglePin, customLabelsCount, pinningLabel }) => {
  const tooltipTitle = isPinned
    ? 'Unpin Label from Chart'
    : customLabelsCount?.pinned_labels.length >= MAX_PINNED_LABELS_COUNT
    ? `${MAX_PINNED_LABELS_COUNT} Labels max`
    : 'Pin Label to Chart'

  return pinningLabel ? (
    <LoadingWrapper>
      <CircularProgress size={16} color="secondary" />
    </LoadingWrapper>
  ) : (
    <LibraryDetailsHoverTooltip title={tooltipTitle} placement="bottom-end">
      <IconButton
        size="small"
        onClick={togglePin}
        className={`pinned-button ${
          isPinned
            ? 'is-pinned'
            : customLabelsCount?.pinned_labels.length >= MAX_PINNED_LABELS_COUNT
            ? 'is-disabled'
            : ''
        }`}
      >
        <PinSvg
          isPinned={isPinned ? true : customLabelsCount?.pinned_labels.length >= MAX_PINNED_LABELS_COUNT ? null : false}
        />
      </IconButton>
    </LibraryDetailsHoverTooltip>
  )
}

export default LabelCardPinButton
